import React from 'react';
import { Key, Loader2, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { CopyButton } from './CopyButton';

export const ApiKeyTab = ({
  config, apiBase, rotating, onRotateRequest,
  fixedKeyInput, setFixedKeyInput, settingKey, onSetKey,
}) => (
  <Card className="bg-white border-slate-200">
    <CardHeader>
      <CardTitle className="text-slate-900 flex items-center gap-2">
        <Key className="w-5 h-5 text-indigo-700" /> Chave de API de Provisionamento
      </CardTitle>
      <CardDescription className="text-slate-500">
        O CogniHub usa esta chave no header <code className="text-indigo-700">X-API-Key</code> para criar e gerir clientes
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="space-y-2">
        <Label className="text-slate-600">Chave atual (mascarada)</Label>
        <div className="flex items-center gap-2">
          <Input readOnly value={config?.api_key_masked || '—'}
            className="bg-white border-slate-300 text-slate-900 font-mono" data-testid="masked-key-input" />
        </div>
        <p className="text-xs text-slate-500">
          Origem: {config?.api_key_rotated ? 'Chave rodada (guardada na base de dados)' : 'Variável de ambiente (.env)'}
        </p>
      </div>

      <div className="space-y-2">
        <Label className="text-slate-600">URL base da API</Label>
        <div className="flex items-center gap-2">
          <Input readOnly value={`${apiBase}/api/provisioning`}
            className="bg-white border-slate-300 text-slate-900 font-mono text-sm" data-testid="api-base-input" />
          <CopyButton value={`${apiBase}/api/provisioning`} />
        </div>
      </div>

      <Separator className="bg-slate-700" />

      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
        <div>
          <Label className="text-slate-900">Rodar chave de API</Label>
          <p className="text-sm text-slate-500 mt-1">
            Gera uma nova chave e invalida a anterior. Atualize o CogniHub de seguida.
          </p>
        </div>
        <Button onClick={onRotateRequest} disabled={rotating}
          className="bg-indigo-700 hover:bg-amber-600 text-black" data-testid="rotate-key-btn">
          {rotating ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
          Gerar nova chave
        </Button>
      </div>

      <div className="p-4 bg-slate-50 rounded-lg space-y-2">
        <Label className="text-slate-900">Definir chave fixa</Label>
        <p className="text-sm text-slate-500">
          Cole uma chave específica para usar em vez de gerar aleatoriamente. Útil para manter a <strong>mesma chave em preview e produção</strong>.
        </p>
        <div className="flex items-center gap-2">
          <Input value={fixedKeyInput} onChange={(e) => setFixedKeyInput(e.target.value)}
            placeholder="Cole aqui a chave fixa (mín. 20 caracteres)"
            className="bg-white border-slate-300 text-slate-900 font-mono" data-testid="fixed-key-input" />
          <Button onClick={onSetKey} disabled={settingKey || fixedKeyInput.trim().length < 20}
            className="bg-slate-900 hover:bg-slate-800 text-white shrink-0" data-testid="set-key-btn">
            {settingKey ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Definir chave
          </Button>
        </div>
      </div>
    </CardContent>
  </Card>
);
